import React from 'react';
import PropTypes from 'prop-types';

import { createComponent } from '@cloudflare/style-container';

var ArrowRendererWrapper = createComponent(function (_ref) {
  var theme = _ref.theme,
      isOpen = _ref.isOpen;
  return {
    borderColor: isOpen ? 'transparent transparent ' + theme.colors.gray[4] : theme.colors.gray[4] + ' transparent transparent',
    borderWidth: isOpen ? '0 5px 5px' : '5px 5px 2.5px',
    borderStyle: 'solid',
    display: 'inline-block',
    height: 0,
    width: 0
  };
});
ArrowRendererWrapper.setDisplayName('ArrowRendererWrapper');
export default function arrowRenderer(_ref2) {
  var onMouseDown = _ref2.onMouseDown;

  return React.createElement(ArrowRendererWrapper, { onMouseDown: onMouseDown });
}

arrowRenderer.propTypes = {
  onMouseDown: PropTypes.func
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/component-select/es/arrowRenderer.js
// module id = 1115
// module chunks = 1